import React from "react";
import { CarIcon, HandHeartIcon, LockKeyholeIcon, MessagesSquareIcon, UserRoundCheckIcon, WalletIcon } from "lucide-react";
import { differentiators } from "../../data/home";
import { images } from "../../data/images";
import { Reveal } from "../ui/Reveal";
import { SectionHeading } from "../ui/SectionHeading";
const icons = {
  respect: HandHeartIcon,
  personal: UserRoundCheckIcon,
  consult: MessagesSquareIcon,
  ride: CarIcon,
  payment: WalletIcon,
  private: LockKeyholeIcon
};
export function WhyDifferent() {
  return <section aria-labelledby="why-title" className="grain section-y gutter bg-navy text-white" data-id="element-303" data-mp="2btts8murgn2x">
      <div className="grid items-center gap-[clamp(3rem,6vw,8rem)] lg:grid-cols-2 ultra:grid-cols-[1fr_1.2fr]" data-id="element-304" data-mp="1xulrhpiy96wm">
        <div data-id="element-305" data-mp="22tozniu87t8t">
          <SectionHeading id="why-title" tone="dark" eyebrow="Welcome to Post Bail Bonds Inc." title={<>
                A local team that <em className="text-gold-soft" data-id="element-307" data-mp="y4rh17bhgv3">stays with you.</em>
              </>} data-id="element-306" data-mp="3s6sedll7hc4r" />
          <div className="measure mt-8 space-y-5 text-lg text-white/75" data-id="element-308" data-mp="1j97k2zul8x7q">
            <p data-id="element-309" data-mp="1j74xkpsn9m7r">
              Whether this is your first time navigating bail or you're helping someone through repeated arrests, we're here to give you the support you need — with respectful treatment and personal attention during and after the bond.
            </p>
            <p data-id="element-310" data-mp="14cqaad21rqna">
              Unlike large corporations, we stay with each client. Your case is handled with complete confidentiality, and bonds are issued promptly.
            </p>
          </div>
        </div>
        <Reveal data-id="element-311" data-mp="1ebpla2aabydg">
          <figure className="relative overflow-hidden rounded-3xl border border-gold/25 shadow-glass" data-id="element-312" data-mp="1e81qkzt3t5x5">
            <img src={images.family} alt="An adult daughter embracing her father outside at dawn" loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-313" data-mp="19d4m866rrkql" />
            <figcaption className="glass absolute bottom-5 left-5 right-5 rounded-2xl px-5 py-4 text-sm text-white/90 sm:right-auto" data-id="element-314" data-mp="2kp5evw6r7tbm">
              Respect, privacy, and a ride home — at no extra cost.
            </figcaption>
          </figure>
        </Reveal>
      </div>

      <ul className="mt-[clamp(4rem,7vw,7rem)] grid grid-cols-1 gap-4 min-[480px]:grid-cols-2 lg:grid-cols-3 ultra:grid-cols-6" data-id="element-315" data-mp="31r2t2bmk2zvs">
        {differentiators.map((d, i) => {
        const Icon = icons[d.key];
        return <Reveal as="li" key={d.key} delay={i * 0.08} className="flex h-full flex-col rounded-2xl border border-gold/25 bg-white/[0.03] p-[clamp(1.5rem,2vw,2rem)]" data-id="element-316" data-mp="2948a5j5e08kf" data-mpi={i}>
              <span className="grid h-14 w-14 place-items-center rounded-2xl border border-white/10 bg-navy-800" aria-hidden="true" data-id="element-317" data-mp="2j0l3uh0xmmf6">
                <Icon className="h-6 w-6 text-gold-soft" strokeWidth={1.5} data-id="element-318" data-mp="2nsl98ozru7j5" />
              </span>
              <h3 className="mt-6 font-serif text-2xl" data-id="element-319" data-mp="1qbmkjgl2pe8a">{d.title}</h3>
              <p className="mt-2 text-white/70" data-id="element-320" data-mp="1vaz33p4wvz52">{d.body}</p>
            </Reveal>;
      })}
      </ul>
    </section>;
}